export enum NotificationOptions {
  ALL = 'all',
  READ = 'read',
  UNREAD = 'unread',
}
